// Tracks which sprint reports the current browser has opened, so the "New" badge can disappear once
// a client has visited a sprint at least once. Client-side only (localStorage) — no backend state.
const STORAGE_KEY = 'phill-client-visited-sprints';

const read = (): string[] => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as string[]) : [];
  } catch {
    return [];
  }
};

export const sprintVisitKey = (productId?: string, sprintId?: string): string => `${productId ?? ''}:${sprintId ?? ''}`;

export const isSprintVisited = (productId?: string, sprintId?: string): boolean =>
  read().includes(sprintVisitKey(productId, sprintId));

export const markSprintVisited = (productId?: string, sprintId?: string): void => {
  const key = sprintVisitKey(productId, sprintId);
  const visited = read();
  if (!visited.includes(key)) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...visited, key]));
  }
};
